import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { PortDrayage } from '@/screens/Port-Drayage';

export default function PortDrayagePage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="drayage, port drayage, port drayage services, port drayage solutions"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Port Drayage Services | Loadsmart"
        description="Price and tender port drayage shipments in seconds with our national drayage services. Improve visibility with real time tracking and full integration with port operators, truckers, and warehouses."
        canonical="https://loadsmart.com/port-drayage/"
        openGraph={{
          url: 'https://loadsmart.com/port-drayage/',
        }}
      />
      <PortDrayage />
    </>
  );
}
